import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/authGurd';
import { LayoutComponent } from './shared/layout/layout.component';
import { ErrorComponent } from './shared/error/error.component';
import { ProductInfoComponent } from './pages/product-info/product-info.component';

const appRoutes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'main',
    component: LayoutComponent,
    data: {
      breadcrumb: null,
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },

      {
        path: 'executive-dashboard',
        loadChildren: () =>
          import('./pages/executive-dashboard/executive-dashboard.module').then(
            (m) => m.ExecutiveDashboardModule
          ),
      },

      {
        path: 'product-information',
        component: ProductInfoComponent,
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile/profile.module').then((m) => m.ProfileModule),
      },

      {
        path: 'sa',
        data: { breadcrumb: 'System Admin', labelId: 'L_System_Admin' },
        loadChildren: () =>
          import('./pages/sa/sa.module').then((m) => m.SaModule),
      },

      {
        path: 'business-impact',
        loadChildren: () =>
          import('./pages/business-impact/business-impact.module').then(
            (m) => m.BusinessImpactModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'bia-consolidation',
        loadChildren: () =>
          import('./pages/bia-consolidation/bia-consolidation.module').then(
            (m) => m.BiaConsolidationModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'business-continuity',
        loadChildren: () =>
          import('./pages/business-continuity/business-continuity.module').then(
            (m) => m.BusinessContinuityModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'bcp-consolidation',
        loadChildren: () =>
          import('./pages/bcp-consolidation/bcp-consolidation.module').then(
            (m) => m.BcpConsolidationModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'bcp-invocation',
        loadChildren: () =>
          import(
            './pages/business-continuity/bcp-invocation/bcp-invocation-routing.module'
          ).then((m) => m.BcpInvocationRoutingModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'risk-assessment',
        loadChildren: () =>
          import('./pages/risk-assessment/risk-assessment.module').then(
            (m) => m.RiskAssessmentModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'mitcon',
        loadChildren: () =>
          import('./pages/mitcon/mitcon.module').then((m) => m.MitconModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'crisis-management',
        loadChildren: () =>
          import('./pages/crisis-management/crisis-management.module').then(
            (m) => m.CrisisManagementModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'ia-tracker',
        loadChildren: () =>
          import('./pages/ia-tracker/ia-tracker.module').then(
            (m) => m.IaTrackerModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'disaster-management',
        loadChildren: () =>
          import('./pages/disaster-management/disaster-management.module').then(
            (m) => m.DisasterManagementModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'dr-exercise',
        loadChildren: () =>
          import('./pages/testing/dr-exercise/dr-exercise.module').then(
            (m) => m.DrExerciseModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'activity-manager',
        loadChildren: () =>
          import('./pages/activity-manager/activity-manager.module').then(
            (m) => m.ActivityManagerModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'emergency-notifications',
        loadChildren: () =>
          import(
            './pages/emergency-notifications/emergency-notifications.module'
          ).then((m) => m.EmergencyNotificationsModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'reporting',
        loadChildren: () =>
          import('./pages/reporting/reporting.module').then(
            (m) => m.ReportingModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'testing',
        loadChildren: () =>
          import('./pages/testing/testing.module').then((m) => m.TestingModule),
        canActivate: [AuthGuard],
      },

      {
        path: 'generator',
        loadChildren: () =>
          import('./pages/generator/generator.module').then(
            (m) => m.GeneratorModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'record-management',
        data: {
          breadcrumb: 'Record Management',
          labelId: 'L_RECORD_MANAGEMENT',
        },
        loadChildren: () =>
          import('./pages/record-management/record-management.module').then(
            (m) => m.RecordManagementModule
          ),
        canActivate: [AuthGuard],
      },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: 'error',
    component: ErrorComponent,
  },

  {
    path: '',
    redirectTo: '/main/dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
